<script setup>
import { provide, ref } from "vue"
import { useDisplay } from "vuetify"
import { useAccount } from "@/composables/useAccount.js"
import PFooter from "@/components/PFooter.vue"
import PAppBar from "@/components/PAppBar.vue"
import PNavigationDrawer from "@/components/PNavigationDrawer.vue"

const { smAndDown } = useDisplay()
const { isAuthenticated } = useAccount()
const drawer = ref(true)
const navigation = [
  {
    title: "Overview",
    icon: "$mdiViewDashboard",
    to: "/overview",
    show: () => true,
  },
  {
    title: "Account",
    icon: "$mdiAccountBox",
    to: "/account",
    show: () => true,
  },
  {
    title: "Invoices",
    icon: "$mdiReceiptText",
    to: "/invoices",
    params: true,
    show: user => user.role !== "involved_reseller",
  },
  {
    title: "Upload",
    icon: "$mdiFileUpload",
    to: "/upload",
    show: user => user.role !== "distributor",
  },
  {
    title: "Multi-platform probe",
    icon: "$mdiRouterNetwork",
    to: "/multi-platform-probe",
    show: user => user.role !== "distributor",
  },
]
const showFetchingIndicator = ref(false)
const updateFetchingIndicator = (val) => {
  showFetchingIndicator.value = val
}
provide("updateFetchingIndicator", updateFetchingIndicator)
</script>

<template>
  <v-app>
    <template v-if="isAuthenticated">
      <p-navigation-drawer
        v-model="drawer"
        :items="navigation"
      />
      <p-app-bar
        :loading="$router.state.loading"
        @click="drawer = true"
      >
        {{ smAndDown ? 'Partner Portal' : 'Paessler PRTG Hosted Monitor - Partner Portal' }}
      </p-app-bar>
      <v-main>
        <router-view
          v-slot="{ Component }"
          appear
        >
          <v-slide-x-transition mode="out-in">
            <component :is="Component" />
          </v-slide-x-transition>
        </router-view>
      </v-main>
      <v-progress-circular
        v-if="showFetchingIndicator"
        class="center-vert-horiz"
      />
      <v-snackbar
        :color="$toast.type"
        :model-value="$toast.show"
        multi-line
      >
        {{ $toast.message }}
        <template #actions>
          <v-btn
            color="white"
            @click="$toast.clear"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <p-footer />
    </template>
    <v-progress-circular
      v-else
      class="center-vert-horiz"
    />
  </v-app>
</template>

<style lang="scss">
.center-vert-horiz {
  position: fixed;
  top: 50%;
  left: 50%;
  text-align: center;
}
</style>
